import { useStore } from 'vuex';
import { computed } from 'vue';

import { SetFilters, SetFiltersObject, SetInitialFilters } from '~/constants/actions';
import { GetFilters, GetSearchQuery } from '~/constants/getters';
import { SetQueryValue } from '~/constants/mutations';

export default () => {
  const store = useStore();

  const formFilters = computed(() => store.getters[`formFiltersStore/${GetFilters}`]);
  const searchQuery = computed(() => store.getters[`formFiltersStore/${GetSearchQuery}`]);

  const setFilters = (data) => store.dispatch(`formFiltersStore/${SetFilters}`, data);
  const setFiltersObject = (data) => store.dispatch(`formFiltersStore/${SetFiltersObject}`, data);
  const setInitialFilters = (data) => store.dispatch(`formFiltersStore/${SetInitialFilters}`, data);
  const setSearchQuery = (data) => store.dispatch(`formFiltersStore/${SetQueryValue}`, data);
  // const setDefaultState = () => store.dispatch(`conversationStore/${SetConversationDefaultState}`);

  return {
    formFilters,
    searchQuery,
    setFilters, // setDefaultState,
    setInitialFilters,
    setSearchQuery,
    setFiltersObject,
  };
};
